/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // app filter options toggle
var appFilters = document.getElementsByClassName('boost-pfs-filter-option');
if (appFilters.length > 0) {
  setTimeout(function(){
   var element = document.querySelector('.boost-pfs-viewcart a');
   element.innerHTML=document.getElementsByClassName("js-cart-checkout")[0].innerHTML;
    
   var min_title = document.querySelector('.boost-pfs-minicart-title'); 
   min_title.innerHTML= document.querySelector(".cart-dropdown__head p").innerHTML; 

    var itemA = document.getElementsByClassName('boost-pfs-checkout-action')[0];
    var div = document.createElement('em');
    div.className = 'shiipping-info';
    div.innerHTML = document.getElementsByClassName("cart-ship-note")[0].innerHTML
    itemA.before(div);
    
 document.querySelectorAll('.boost-pfs-filter-option-title-text').forEach((event) => {
      event.addEventListener('click', function(e) {
         this.parentNode.parentNode.parentNode.classList.add("active-click");
         document.querySelectorAll('.boost-pfs-filter-option').forEach((ev) => {
            if(ev.classList.contains('active-click')){}
            else {          
               var clslist =  ev.getElementsByTagName('div')[1].classList;
               if(clslist.contains('toggled')) {

               }
               else {
                   ev.getElementsByClassName("boost-pfs-filter-option-title-text")[0].click();
               }
            }
           ev.classList.remove('active-click');
         });
      });
   });
 }, 2000);
  
  var cartObj = window.cart;
  document.body.addEventListener('click', function (event) {
  // document.querySelector("html").classList.remove("boost-pfs-body-no-scroll-mini-cart");
  var element = document.querySelector('.header__cart__status');
  var dataAttribute = element.getAttribute('data-cart-count');
  setTimeout(function() {
      if(event.target.className == 'boost-pfs-quickview-cart-btn-text' || event.target.className == 'boost-pfs-addtocart-btn-text') { 
        var appCart =  document.querySelector(".boost-pfs-minicart-wrapper").classList;
         if(appCart.contains("boost-pfs-minicart-show")) cartObj.getCart();
      
        /*
        setTimeout(function() {
        var  cartCount = element.getAttribute('data-cart-count');
          if(cartCount != dataAttribute) {
              cartObj.getCart();
           // document.getElementsByClassName('navlink--cart ')[0].click();
           // cartObj.openCartDropdown();

          }
          }, 1000);
        */
        	
      }
     if(event.target.className == 'boost-pfs-minicart-item-remove-text') cartObj.getCart();
      }, 3000);		
  });
  

}


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
